"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Image", {
  enumerable: true,
  get: function () {
    return _Image.Image;
  }
});
var _Image = require("./Image");
//# sourceMappingURL=index.js.map